(function($) {

"use strict";

/** --------------------------------------------------
*
*   pages - user - REGISTER PAGE
*
*   INFO
*   extra client side validation for the registration
*   form
*
*   TABLE OF CONTENTS
*   drupal behavior
*   register form
*   helper functions
*
*   -------------------------------------------------- */




/** --------------------------------------------------
*   #drupal behavior
*   -------------------------------------------------- */

Drupal.behaviors.setupRegisterPage = {
	attach: function (context, settings) {

		if(isUserAccountPage()) {

			var ua_parser = new UAParser();
			var ua_result = ua_parser.getResult();
			var browserName = ua_result.browser.name;
			if(browserName !== 'Safari') {
				setupRegisterForm();
			}

            setupPostalCodeWatcher();
		}

	}
};



/** --------------------------------------------------
*   #register form
*   -------------------------------------------------- */

function setupRegisterForm() {
	// check form:
	$('.user-register-form .js-form-submit').once().on('click', checkFormInput);
} /* setupRegisterForm */

function checkFormInput() {

	/* VAT number */
	/* ********** */

	// if the VAT number is required, check that there are no
	// underscores in it

	const $vat_input = $('[data-drupal-selector="vat-0"]');
	if($vat_input.length > 0) {
		const vat_input = $vat_input[0];
		const vatIsRequired = $vat_input.attr('required') === 'required';
		if(vatIsRequired) {
			const vatInputValue = vat_input.value;
			let vatIsValid = true;
			if(vatInputValue.indexOf('_') > -1) {
				vatIsValid = false;
			}
			if (vatIsValid) {
				vat_input.setCustomValidity('');
			} else {
				vat_input.setCustomValidity(Drupal.t('Please enter a correct VAT number'));
			}
		}
	}

	/* phone */
	/* ***** */

	// a mobile or phone number is required

	const $mobileInput = $('[data-drupal-selector="edit-field-mobile-phone-0-value"]');
	const $phoneInput = $('[data-drupal-selector="edit-field-telephone-0-value"]');
	if($mobileInput.length > 0&& $phoneInput.length > 0) {
		const mobileInput = $mobileInput[0];
		const phoneInput = $phoneInput[0];
		const mobileInputValue = mobileInput.value;
		const phoneInputValue = phoneInput.value;
		if(mobileInputValue === '' && phoneInputValue === '') {
			mobileInput.setCustomValidity(Drupal.t('Please enter mobile number or a telephone number'));
		} else {
			mobileInput.setCustomValidity('');
		}
	}

	/* salutation */
	/* ********** */

	// if a salutation is required, one of the radiobuttons needs to be checked

	const $salutationBlock = $('[data-drupal-selector="edit-field-salutation"]');
	if($salutationBlock.length > 0) {
		const salutationIsRequired = $salutationBlock.attr('required') === 'required';
		if(salutationIsRequired) {

			const $salutationRadios = $salutationBlock.find('.form-radios input[type="radio"]');
			const firstRadio = $salutationRadios.first()[0];
			if($salutationRadios.length > 0) {
				let aRadioIsChecked = false;
				$salutationRadios.each(function(index, element) {
					const radio = $(element)[0];
					if(radio.checked) {
						aRadioIsChecked = true;
					}
				});
				if(aRadioIsChecked) {
					firstRadio.setCustomValidity('');
				} else {
					firstRadio.setCustomValidity(Drupal.t('Please select a value'));
				}
			}
		}
	}

	/* sector */
	/* ****** */

	// if a sector is required, one of the checkboxes needs to be checked

	const $sectorBlock = $('[data-drupal-selector="edit-field-user-sector"]');
	if($sectorBlock.length > 0) {
		const sectorIsRequired = $sectorBlock.attr('required') === 'required';
		if(sectorIsRequired) {

			const $sectorCheckboxes = $sectorBlock.find('.form-checkboxes input[type="checkbox"]');
			const firstCheckbox = $sectorCheckboxes.first()[0];
			if($sectorCheckboxes.length > 0) {
				let aCheckboxIsChecked = false;
				$sectorCheckboxes.each(function(index, element) {
					const checkbox = $(element)[0];
					if(checkbox.checked) {
						aCheckboxIsChecked = true;
					}
				});
				if(aCheckboxIsChecked) {
					firstCheckbox.setCustomValidity('');
				} else {
					firstCheckbox.setCustomValidity(Drupal.t('Please select a value'));
				}
			}
		}
	}

	/* preferred communication method */
	/* ****************************** */

	// if a communication method is required, one of the checkboxes needs to be checked

	const $updatesBlock = $('[data-drupal-selector="edit-field-updates"]');
	if($updatesBlock.length > 0) {
		const updateMethodIsRequired = $updatesBlock.attr('required') === 'required';
		if(updateMethodIsRequired) {

			const $methodCheckboxes = $updatesBlock.find('.form-checkboxes input[type="checkbox"]');
			const firstCheckbox = $methodCheckboxes.first()[0];
			if($methodCheckboxes.length > 0) {
				let aCheckboxIsChecked = false;
				$methodCheckboxes.each(function(index, element) {
					const checkbox = $(element)[0];
					if(checkbox.checked) {
						aCheckboxIsChecked = true;
					}
				});
				if(aCheckboxIsChecked) {
					firstCheckbox.setCustomValidity('');
				} else {
					firstCheckbox.setCustomValidity(Drupal.t('Please select a value'));
				}
			}
		}
	}

} /* checkFormInput */


function setupPostalCodeWatcher() {
    const $billingAddressPcInput = $('input[name="entity_customer[address][0][address][postal_code]"]');
    const $deliveryAddressPcInput = $('input[name="field_delivery_address[0][address][postal_code]"]');

    $billingAddressPcInput.on('input', function(e) {
        // This field is already hooked up to ajax callback in custom form to trigger
        // a response to fetch matching localities on 'change' but this only happens when
        // the input loses focus. Client wants it to happen automagically after the
        // "final number of postal code" was entered. (Currently 4 digits as BE only)
        if (this.value.length == 4) {
            this.blur();
        }
    });

    $deliveryAddressPcInput.on('input', function(e) {
        if (this.value.length == 4) {
            this.blur();
        }
    });
} /* setupPostalCodeWatcher */


/** --------------------------------------------------
 *  #helper functions
 *  -------------------------------------------------- */

function isUserAccountPage() {
	let isUserPage = false;

	if($('body').hasClass('path-user')) {
		isUserPage = true;
	}

	return isUserPage;
} /* isUserAccountPage */




})(jQuery);
